import React from 'react';
import { usePanels } from './App';

const ServicesPanel = () => {
  const { swapPanel } = usePanels();

  return (
    <div id="servicesPanel" className="Panel Panel-right">
      <button 
        className="btn-back left-panel-btn" 
        onClick={() => swapPanel('menu', 'leftPanel')}
      >
        ⬅ Back
      </button>
      <section>
        <h2>Priorities</h2>
        <p>Australia is labelled as "an AI laggard". We will change that. Together.</p>
        <p>Our priority is to provide end-to-end advisory services to help SMEs (especially in education, energy, food and other social impact sectors) become “AI-ready.” 
            This can range from AI-readiness audits, to tech transformation coaching, to ethical AI integration frameworks. These consulting engagements can be project-based or retainer-based. 
            Emphasis is placed on social responsibility – helping clients harness AI to benefit society and the environment, not just efficiency or profit.
        </p>
      </section>

      <section>
        <h2>AI-Readiness</h2>
        <p>
          A comprehensive review of your organization's processes, data, and culture to gauge AI opportunities and challenges.
          Are there any low-hanging AI fruits to boost your business?
        </p>
      </section>

      <section>
        <h2>Ethical AI Framework & Training</h2>
        <p>
          A workshop with small team to showcase what tools are available. Brainstorming and 
          suggestions specific for your business with an extensive Q&A session. Equipping your team with
          knowledge to enter the magical realm of AI.
        </p>
      </section>

      <section>
        <h2>Turnkey AI Solutions</h2>
        <p>
          Don't have resources to implement the AI tools internally? Maybe, we can build them for you. 
          Let's chat!
        </p>
      </section>

      <section>
        <h2>"Impact" Consulting</h2>
        <p>
           We are not just about AI. We are about using technology to make a difference. Are you, too? Let's do it together!
        </p>
      </section>

      <section>
        <h2>Contact us</h2>
        <p>Drop us an email: <a href="mailto:admin@psycode.com.au">admin@psycode.com.au</a></p>
        <p>
          <span onClick={() => swapPanel('contact', 'rightPanel')} style={{cursor: 'pointer', textDecoration: 'underline'}}>
            Or send a message directly through the Contact us form (click here).
          </span>
        </p>
        <p>Or connect with us on LinkedIn: <span onClick={() => window.open('https://www.linkedin.com/company/psycode/', '_blank')} style={{cursor: 'pointer', textDecoration: 'underline'}}>
          https://www.linkedin.com/company/psycode/
        </span></p>
        <p>
          And if you are in Sydney, we would love to grab a coffee some time!  ☕ 
        </p>
      </section>
    </div>
  );
};

export default ServicesPanel;
